import React from "react";
import { ViewGroup } from "./actionButtons/ViewGroup";
import { DeleteGroup } from "./actionButtons/DeleteGroup";

function TableRow(props) {
  const { group, index } = props;

  if (! group) {
    return null;
  }

  return (
    <tr>
      <td>{group.name}</td>
      <td className="w-10">
        <ViewGroup
          group={group}
          index={index}
        />
        <DeleteGroup
          group={group}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
      </td>
    </tr>
  );
}

TableRow.defaultProps = {
  group: null,
};

export { TableRow };
